<template>
    <div id="ModalAddSignatario" class="modal fade in" style="z-index:10000" data-backdrop="false" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-user-plus"></i> Novo signatário</p>
                    <button type="button" class="close" @click="closeModal()" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form-signatario :request="form"></form-signatario>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="float-left btn btn-default" @click="closeModal()"><i
                            class="fa fa-times"></i> {{$t('words.close')}}</button>
                    <button type="button" :disabled="loading" @click="addUser()" class="btn btn-success"><i
                            class="fa fa-plus"></i>
                        {{$t('words.add')}} <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import formSignatario from '../../../views/grupos-signatario/form-signatario.vue';
    export default {
        components: {
            formSignatario
        },
        props: {
            signatarios: []
        },
        data() {
            return {
                loading: false,
                file: {},
                form: {
                    hasDocument: false,
                    assinatura_nome: null,
                    assinatura_email: null,
                    assinatura_documento: null,
                    assinatura_telefone: null,
                    assinatura_tipo: null,
                    token_tipo: 'E',
                    ordem: 1,
                }
            }
        },
        methods: {
            async addUser() {
                let valid = await this.$validator.validateAll().then(valid => {
                    return valid;
                });
                if (!valid) {
                    return
                }
                try {
                    this.validateUser();
                } catch (e) {
                    return;
                }
                this.insertUser();
            },
            insertUser() {
                toastr({
                    title: 'E-mail adicionado!',
                    icon: 'success'
                });
                this.signatarios.push({
                    ...this.form
                });
                this.form = {
                    hasDocument: false,
                    assinatura_nome: null,
                    assinatura_email: null,
                    assinatura_documento: null,
                    ordem: 1,
                    assinatura_telefone: null,
                    assinatura_tipo: null,
                    token_tipo: 'E',
                }
            },
            closeModal() {
                $('#ModalAddSignatario').modal('hide');
            },
            validateUser() {
                if (this.signatarios.findIndex(
                        x => x.assinatura_email == this.form.assinatura_email &&
                        x.assinatura_tipo == this.form.assinatura_tipo) > -1) {
                    toastr({
                        title: 'E-mail já adicionado para esse tipo de assinatura!',
                        icon: 'warning'
                    });
                    throw 'E-mail já adicionado';
                }
            },

        }
    }
</script>